<template>
  <div class="createGroup-dialog">
    <gs-modal
      v-model="visible"
      :before-close="beforeClose"
      :before-confirm="beforeConfirm"
      :has-form="true"
      class="createGroup-dialog-modal"
      title="新建-用户组"
      @cancel="close"
      @close="close"
      @confirm="handleConfirm"
    >
      <div class="page-form">
        <gs-form
          ref="form"
          :model="form"
          class="form"
          label-width="60px"
          label-position="left"
          gap="small"
        >
          <gs-form-item
            label="用户组名:"
            prop="groupName"
            class="form-item-groupName"
          >
            <gs-input
              ref="nameInput"
              v-model="form.groupName"
              type="text"
            />
          </gs-form-item>
        </gs-form>
      </div>
    </gs-modal>
  </div>
</template>
<script>
import service from '../../service/authorityService.js'
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
  data() {
    return {
      form: {
        groupName: ''
      }
    }
  },
  computed: {
    ...mapState({
      visible: 'createGroupShow'
    })
  },
  watch: {
    visible() {
      if (this.visible) {
        this.form.groupName = ''
        setTimeout(() => {
          this.$refs.nameInput.focus()
        }, 100)
      }
    }
  },
  methods: {
    ...mapMutations({
      close: 'CREATE_GROUP_HIDE',
      needReload: 'NEED_RELOAD_TREE'
    }),
    handleConfirm() {
      service.saveGroup(this.form).then(res => {
        this.$Message.success('创建用户组成功!')
        this.form.groupName = ''
        this.close()
      }).catch(err => {
        this.$Message.error(err.message)
      })
    },
    beforeConfirm(e, done) {
      if (this.form.groupName === null || this.form.groupName === '') {
        this.$Message.warning('用户组名不能为空')
        return
      }
      done()
    },
    beforeClose(e, done) {
      // done(false)可以阻止modal关闭
      this.close()
    }
  }
}
</script>
<style lang="scss" scoped>
.createGroup-dialog {
  &-modal {
    .page-form {
      .title {
        color: #0073e8;
        margin-bottom: 12px;
      }
      .gs-form-item {
        margin-bottom: 12px;
      }
      .button {
        float: right;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/authority/createGroup.vue